import { resolver } from "@msuite/ui/libs/form";
import { useTranslation } from "@msuite/ui/localization";
import { Modal, type ModalProps } from "@msuite/ui/modal";
import { responseHandler } from "@msuite/ui/utils";
import { type TourWaveFormSchema, tourWaveFormSchema } from "@msuite/utils/schemas";
import { FormProvider, useForm } from "react-hook-form";
import { TourWaveForm } from "@/forms/tour-wave-form";
import { client } from "@/hono";

/** Props Interface */
interface AddTourWaveModalProps extends ModalProps {
	onComplete?: () => Promise<void>;
}

export function AddTourWaveModal({ onClose, isOpen, onComplete }: AddTourWaveModalProps) {
	/** Hooks */
	const { t } = useTranslation();
	const methods = useForm({
		resolver: resolver(tourWaveFormSchema),
	});

	/** Functions */
	async function handleOnSubmit(json: TourWaveFormSchema) {
		const response = await client.stock["tour-waves"].$post({ json });
		await responseHandler(response);
		await onComplete?.();
		onClose();
	}

	/** Render */
	return (
		<FormProvider {...methods}>
			<Modal
				title={t("stock.add_tour_wave")}
				isOpen={isOpen}
				onClose={onClose}
				onSubmit={methods.handleSubmit(handleOnSubmit)}
			>
				<Modal.Body>
					<TourWaveForm />
				</Modal.Body>
				<Modal.FooterForm />
			</Modal>
		</FormProvider>
	);
}
